"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.updateNonBookableMarkers = exports.clearLocationMarker = exports.animateLocationMarker = void 0;
var _set = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
/**
 * @param {maplibregl.Marker[]} markers
 * @param {Array} locations
 */
const updateNonBookableMarkers = (markers, locations) => {
  const nonBookableIds = new _set.default((0, _map.default)(locations).call(locations, loc => loc.id));
  if (nonBookableIds.size) {
    (0, _forEach.default)(markers).call(markers, _ref => {
      let {
        marker,
        meta
      } = _ref;
      if (nonBookableIds.has(meta.location.id)) {
        marker.addClassName('nonbookable');
      }
    });
  }
};

// https://healthsparq.atlassian.net/browse/KENG-41045
exports.updateNonBookableMarkers = updateNonBookableMarkers;
const animateLocationMarker = () => {};
exports.animateLocationMarker = animateLocationMarker;
const clearLocationMarker = () => {};
exports.clearLocationMarker = clearLocationMarker;